import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PartnerTierAssignmentRow } from "@colab/shared";

// GET /api/admin/tiers/programs/:id/assignments — partner-tier assignments
// for one program, with `partner_name` + `tier_name` joined in for the
// assignments-tab table.
//
// Phase 7 sub-bucket 12. The key is invalidated by useAssignPartnerTier +
// useUnassignPartnerTier (Phase 6 bucket 7) so the table refreshes after
// any assignment mutation.
export type AdminTierAssignmentRow = PartnerTierAssignmentRow & {
  partner_name: string;
  tier_name: string;
};

export function useAssignmentsForProgram(programId: string | undefined) {
  return useQuery<AdminTierAssignmentRow[], ApiClientError>({
    queryKey: programId
      ? queryKeys.tiers.assignmentsForProgram(programId)
      : ["tiers", "program", "__missing__", "assignments"],
    queryFn: () =>
      apiFetch<AdminTierAssignmentRow[]>(
        `/admin/tiers/programs/${programId}/assignments`,
      ),
    enabled: !!programId,
  });
}
